// styles.scss = Bootstrap + theme styles (global CSS, no CSS Modules hashing)
import './styles.scss';

function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {
    options = {
        path: '/',
        ...options
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}

// Wrap tables outside of any scroll-blocking context
document.querySelectorAll('table').forEach(table => {
    if (!table.parentElement.classList.contains('table_wrap')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'table_wrap';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // Lazy-load images inside #scroll-to-form context
    if (document.getElementById('scroll-to-form')) {
        document.querySelectorAll('img[data-lazy-type="image"]').forEach(img => {
            const dataSrc = img.getAttribute('data-src');
            if (dataSrc) {
                img.setAttribute('src', dataSrc);
                img.removeAttribute('data-src');
                img.classList.remove('lazy-hidden');
            }
        });
    }

    // Scrollable content sections
    document.querySelectorAll('.scrollable-content-wrap').forEach(section => {
        initializeScrolling(section);
    });

    // Sidebar & nav toggles
    document.querySelectorAll('.main-nav-content-toggle, .nav-sidebar-header-toggle, .nav-sidebar-overlay').forEach(el => {
        el.addEventListener('click', () => {
            document.querySelector('.sidebar')?.classList.toggle('opened');
            document.getElementById('container')?.classList.toggle('opened');
        });
    });

    // Mobile menu toggle
    document.querySelectorAll('.toggle-menu').forEach(toggle => {
        toggle.addEventListener('click', () => {
            document.querySelector('.mobile-menu-wrap')?.classList.toggle('open');
        });
    });

    // Header bonus toggle
    document.querySelectorAll('.open-close-bonus-header').forEach(toggle => {
        toggle.addEventListener('click', () => {
            document.querySelector('.header-bonus-wrap')?.classList.toggle('open');
        });
    });

    // Submenu: prevent parent link from toggling, handle submenu open
    document.querySelectorAll('.menu-item-has-children > a').forEach(anchor => {
        anchor.addEventListener('click', (event) => {
            event.stopPropagation();
            window.location.href = anchor.href;
        });
    });

    document.querySelectorAll('.menu-item-has-children').forEach(item => {
        item.addEventListener('click', () => {
            item.classList.toggle('toggled');
            item.classList.toggle('space-up');
            item.querySelector('ul')?.classList.toggle('open');
        });
    });

    // Search toggle — different behavior on desktop vs mobile
    const w = window.innerWidth;
    document.querySelectorAll('.header-search-open').forEach(btn => {
        btn.addEventListener('click', () => {
            if (w >= 1200) {
                btn.parentElement?.classList.toggle('open');
            } else {
                document.querySelector('.search-mobile-wrap')?.classList.toggle('open');
            }
        });
    });

    // Scroll-to-top buttons
    document.querySelectorAll('.slide-up').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });

    // Scroll to feedback form
    const scrollToFormBtn = document.getElementById('scroll-to-form');
    if (scrollToFormBtn) {
        scrollToFormBtn.addEventListener('click', (e) => {
            e.preventDefault();
            setTimeout(() => {
                const target = document.getElementById('feedback-form');
                if (target) {
                    const targetOffset = target.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({ top: targetOffset - 100, behavior: 'smooth' });
                }
            }, 300);
        });
    }

    // Lang switcher modal
    const langSwitcherBtn = document.getElementById('lang-switcher-btn');
    const langSwitcherBtnFooter = document.getElementById('lang-switcher-btn-footer');
    const modalWrapper = document.getElementById('m-modal-wrapper');
    const modalClose = document.getElementById('m-modal-close');

    const openModal = () => {
        if (!modalWrapper) return;
        modalWrapper.classList.add('show');
        setTimeout(() => modalWrapper.classList.remove('hidden'), 10);
    };

    langSwitcherBtn?.addEventListener('click', openModal);
    langSwitcherBtnFooter?.addEventListener('click', openModal);

    modalClose?.addEventListener('click', () => {
        modalWrapper?.classList.add('hidden');
        setTimeout(() => modalWrapper?.classList.remove('show'), 300);
    });

    // Payment slider
    initSlider();

    // Feedback form
    initFeedbackForm();

    // Load goto links via AJAX
    initGotoLinks();

    // Bootstrap modal — deferred 4s after page is idle to avoid TBT
    scheduleBootstrapModal();
});

function initializeScrolling(section) {
    const scrollContainer = section.querySelector('.scrollable-content-inner');
    const scrollUpBtn = section.querySelector('.content-up');
    const scrollDownBtn = section.querySelector('.content-down');

    if (!scrollContainer || !scrollUpBtn || !scrollDownBtn) return;

    const scrollAmount = 250;

    function checkContainerHeight() {
        const visible = scrollContainer.offsetHeight >= 700;
        scrollUpBtn.style.display = visible ? 'block' : 'none';
        scrollDownBtn.style.display = visible ? 'block' : 'none';
    }

    checkContainerHeight();

    scrollUpBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
    });

    scrollDownBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ top: scrollAmount, behavior: 'smooth' });
    });

    window.addEventListener('resize', checkContainerHeight, { passive: true });
}

function initSlider() {
    const sliderWrapper = document.querySelector('.slider-wrapper');
    if (!sliderWrapper) return;

    const leftArrow = document.querySelector('.slider-arrow.slider-left');
    const rightArrow = document.querySelector('.slider-arrow.slider-right');

    let currentIndex = 0;
    const itemsToShow = window.innerWidth <= 768 ? 2 : 8;
    const totalItems = sliderWrapper.children.length;

    // Clone items for infinite scroll effect
    Array.from(sliderWrapper.children).forEach(child => {
        sliderWrapper.appendChild(child.cloneNode(true));
    });

    const getItemWidth = () => sliderWrapper.children[0]?.offsetWidth || 0;

    const updateSlider = () => {
        sliderWrapper.style.transition = 'transform 0.3s ease';
        sliderWrapper.style.transform = `translateX(-${currentIndex * getItemWidth()}px)`;
    };

    const resetSlider = () => {
        if (currentIndex >= totalItems) {
            currentIndex = 0;
            sliderWrapper.style.transition = 'none';
            sliderWrapper.style.transform = `translateX(0)`;
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    sliderWrapper.style.transition = 'transform 0.3s ease';
                });
            });
        } else if (currentIndex < 0) {
            currentIndex = totalItems - itemsToShow;
            sliderWrapper.style.transition = 'none';
            sliderWrapper.style.transform = `translateX(-${currentIndex * getItemWidth()}px)`;
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    sliderWrapper.style.transition = 'transform 0.3s ease';
                });
            });
        }
    };

    leftArrow?.addEventListener('click', () => { currentIndex--; resetSlider(); updateSlider(); });
    rightArrow?.addEventListener('click', () => { currentIndex++; resetSlider(); updateSlider(); });

    window.addEventListener('resize', () => { currentIndex = 0; updateSlider(); }, { passive: true });

    sliderWrapper.addEventListener('wheel', (event) => {
        event.preventDefault();
        currentIndex += event.deltaY > 0 ? 1 : -1;
        resetSlider();
        updateSlider();
    }, { passive: false });
}

function initFeedbackForm() {
    const form = document.getElementById('feedback-form');
    if (!form) return;

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        let hasEmpty = false;
        form.querySelectorAll('input, textarea, select').forEach(field => {
            if (!field.value) hasEmpty = true;
        });

        if (!hasEmpty) {
            form.style.transition = 'opacity 0.5s';
            form.style.opacity = '0';
            setTimeout(() => {
                form.style.display = 'none';
                const success = document.querySelector('.feedback-success');
                if (success) {
                    success.style.display = 'flex';
                    success.style.opacity = '0';
                    requestAnimationFrame(() => {
                        success.style.transition = 'opacity 0.5s';
                        success.style.opacity = '1';
                    });
                }
            }, 500);
        } else {
            alert('All fields are required!');
        }
    });
}

function initGotoLinks() {
    if (typeof my_ajax_object === 'undefined') return;

    let links = [];

    fetch(my_ajax_object.ajax_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'action=load_links',
    })
        .then(res => res.text())
        .then(res => {
            try {
                links = JSON.parse(res);
            } catch (e) {
                return;
            }

            document.addEventListener('click', (e) => {
                const target = e.target.closest('.goto');
                if (!target) return;
                e.preventDefault();
                const dataItem = target.getAttribute('data-item');
                const found = links.find(l => l.type == dataItem);
                if (found) {
                    setCookie('goto', found.link, { secure: true, 'max-age': 3600 });
                    window.location.href = '/goto';
                }
            });
        });
}

// Use requestIdleCallback to defer heavy bootstrap modal
// to avoid blocking the main thread during page load (reduces TBT)
function scheduleBootstrapModal() {
    if (getCookie('modalhide')) return;

    const run = () => {
        setTimeout(() => {
            const modal = document.getElementById('exampleModal');
            if (modal && typeof bootstrap !== 'undefined') {
                const bsModal = new bootstrap.Modal(modal);
                bsModal.show();

                modal.querySelectorAll('img[data-lazy-type="image"]').forEach(img => {
                    const dataSrc = img.getAttribute('data-src');
                    setCookie('modalhide', true, { secure: true });
                    if (dataSrc) {
                        img.setAttribute('src', dataSrc);
                        img.removeAttribute('data-src');
                        img.classList.remove('lazy-hidden');
                    }
                });
            }
        }, 4000);
    };

    if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 5000 });
    } else {
        run();
    }
}
